import type { AccountDto } from "@cwm/shared";

import { apiFetch } from "./api";


/**
 * Super-admin-only: every account on the platform. Used by surfaces where
 * a super admin must explicitly pick a tenant (wallet creation, wallet-token
 * creation, cross-tenant filters). Includes tombstoned accounts when the
 * caller passes `includeDisabled: true` so the UI can badge them.
 */
export function listAllAccounts(
  opts: { includeDisabled?: boolean } = {},
): Promise<{ items: AccountDto[] }> {
  const qs = opts.includeDisabled ? "?includeDisabled=true" : "";
  return apiFetch<{ items: AccountDto[] }>(`/_superadmin/accounts${qs}`);
}
